module.exports = __webpack_public_path__ + "fonts/Inter-SemiBold.8b4a1cc.woff";